/**
 * Helper functions to convert optionIds to labels for display
 */

import { IDropdownOptions } from '@shared/interface';

/**
 * Get label from optionId
 */
export const getLabelFromOptionId = (optionId: number | null | undefined, options: IDropdownOptions[]): string => {
  if (!optionId) return '-';
  const option = options.find((opt) => opt.optionId === optionId);
  return option?.label || String(optionId);
};

/**
 * Get labels from array of optionIds
 */
export const getLabelsFromOptionIds = (
  optionIds: number | number[] | string | null | undefined,
  options: IDropdownOptions[],
): string[] => {
  if (!optionIds && optionIds !== 0) return [];

  // Handle single number
  if (typeof optionIds === 'number') {
    return [getLabelFromOptionId(optionIds, options)];
  }

  // Handle string format (comma-separated)
  if (typeof optionIds === 'string') {
    return optionIds.split(',').map((id) => {
      const numId = parseInt(id.trim());
      return getLabelFromOptionId(numId, options);
    });
  }

  // Handle array format
  return optionIds.map((id) => getLabelFromOptionId(id, options));
};
